import { Component, CUSTOM_ELEMENTS_SCHEMA, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-calendly',
  templateUrl: './calendly.component.html',
  styleUrls: ['./calendly.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, ReactiveFormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]})
export class CalendlyComponent implements OnInit {
  @ViewChild('container', { static: true }) container: ElementRef;

  @Input() calendarLink?: string;

  constructor() { }

  async ngOnInit() {
    // Calendly.initInlineWidget({
    //   url: this.calendarLink || 'https://calendly.com/amosupport/5min',
    //   parentElement: this.container.nativeElement
    // });
  }

}
